import { Button } from "@/components/shadcn/button";
import { Check, Copy } from "lucide-react";
import { MouseEvent, ReactNode, useState } from "react";
import { toast } from "sonner";
import { twMerge } from "tailwind-merge";

type Props = {
  text: string;
  label?: string | ReactNode;
  className?: string;
};

const ClickToCopy = ({ text, className = "", label }: Props) => {
  const [copied, setCopied] = useState(false);

  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopied(true);
    toast.success("Copied to clipboard", {
      onDismiss: () => setCopied(false),
      onAutoClose: () => setCopied(false),
    });
  };

  const textInButton = label !== undefined ? label : text;

  return (
    <Button
      variant="outline"
      onClick={onClick}
      className={twMerge("w-fit max-w-full overflow-hidden", className)}
    >
      {copied ? <Check className="text-beneficial" /> : <Copy />}
      {textInButton && <span className="truncate">{textInButton}</span>}
    </Button>
  );
};

export default ClickToCopy;
